export default "__VITE_ASSET__niwNTyWN__"